import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

export function useAcquisition(applyDiscount = false) {
  const [payload, setPayload] = useState(null);
  const [snapshotHint, setSnapshotHint] = useState(null);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);

  const reload = useCallback(() => setRevision((r) => r + 1), []);

  useEffect(() => {
    let cancelled = false;
    setBusy(true);
    const query = new URLSearchParams(window.location.search);
    const snapshotId = query.get('snapshot');

    const load = async () => {
      try {
        let snapshot = null;
        if (snapshotId) {
          try {
            const { data: snap } = await api.get(`/acquisition/snapshots/${encodeURIComponent(snapshotId)}`);
            snapshot = snap;
          } catch {
            // ignore
          }
        }
        const { data } = await api.get('/acquisition/all', { params: { apply_discount: applyDiscount } });
        if (cancelled) return;
        if (snapshot?.config) {
          setPayload({ ...data, config: { ...data.config, ...snapshot.config } });
        } else {
          setPayload(data);
        }
        if (snapshot?.hint) {
          setSnapshotHint({ ...snapshot.hint, snapshotName: snapshot.name });
        }
        setError('');
      } catch {
        if (!cancelled) setError('Não foi possível carregar o dossier.');
      } finally {
        if (!cancelled) setBusy(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [revision, applyDiscount]);

  return { payload, snapshotHint, busy, error, reload };
}

export function useScenarioCompute() {
  const compute = useCallback(async ({ scenarioKey, managementCost = 0, includeWorkingCapital = false, applyDiscount = false }) => {
    const { data } = await api.post('/acquisition/calculate', {
      scenario_key: scenarioKey,
      management_cost_eur: managementCost,
      include_working_capital: includeWorkingCapital,
      apply_discount: applyDiscount,
    });
    return data;
  }, []);
  return { compute };
}
